export default __webpack_public_path__ + "static/media/htw2.262c6edc.svg";